import type { EmojiMartSkinNumber } from '@trello/emoji';

export const convertSkinToServerFormat = (
  emojiMartSkin?: EmojiMartSkinNumber,
) => {
  const skinMap = {
    1: null,
    2: '1F3FB',
    3: '1F3FC',
    4: '1F3FD',
    5: '1F3FE',
    6: '1F3FF',
  };

  return skinMap[emojiMartSkin || 1];
};
